import GenericSvgIconWrapper, {
  GenericSvgIconWrapperProps,
} from "./genericSvgIconWrapper";

import React from "react";
import { SvgIcon } from "@material-ui/core";

const DownloadIconSVG = () => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.83301 8.33301L9.99967 12.4997L14.1663 8.33301"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M10 12.5V2.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);

const DownloadIcon: React.FC<GenericSvgIconWrapperProps> = (props) => {
  return (
    <GenericSvgIconWrapper {...props}>
      <DownloadIconSVG />
    </GenericSvgIconWrapper>
  );
};

export default DownloadIcon;
